// utils/exportUtils.js
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const handleExport = (data, format, fileName = 'Exported_Data') => {
  let  exportData;
  if(fileName==="Collection Report")
    {
  exportData = data.map(row => ({
    'Student ID': row.STUDENT_ID,
    'Name': row.NAME,
  }));
    }
  else
  {
   exportData = data.map(row => ({
    'Student ID': row.STUDENT_ID,
    'Name': row.NAME,
    'Class-Sec': row.CLASS_SEC,
    'Phone': row.PHONE,
    'Class': row.CLASS,
    'Type': row.ADDFEES,
    'Tuition Due': row.TUITION_DUE,
    'Transport Due': row.TRANSPORT_DUE,
    
  }));
}

  if (format === 'excel') {
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Students');
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  } else if (format === 'pdf') {
    const doc = new jsPDF();
    doc.text(`${fileName}`, 14, 16);

    if (exportData.length > 0) {
      autoTable(doc, {
        head: [Object.keys(exportData[0])],
        body: exportData.map(row => Object.values(row)),
        startY: 20,
      });
    } else {
      doc.text('No data to export', 14, 30);
    }

    doc.save(`${fileName}.pdf`);
  }
};
